module.exports = __webpack_public_path__ + "img/login-loslibertadores.b04816a5.svg";